import successIcon from '@/assets/svgs/success.svg';
import errorIcon from '@/assets/svgs/error.svg';

export const Message = {
    success: (message: string, duration = 2000) =>
        ElMessage.success({
            message,
            customClass: 'message__success',
            duration,
            icon: () => <img src={successIcon} width="24px" height="24px" />,
        }),

    error: (message: string, duration = 5000, isShowIcon = true) =>
        ElMessage.error({
            customClass: 'message__error',
            message,
            duration,
            icon: () => <img src={errorIcon} width="24px" height="24px" />,
        }),
};
